import * as React from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import { MemoryRouter, Route, Router } from 'react-router';
import { Link } from 'react-router-dom';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import Seo from "../../Seo";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 30,
        marginBottom: 30
    },
    rootMobile: {
        marginTop: 15,
        marginBottom: 30
    },
    loader: {
        marginTop: 10
    }

}));

export function Pager(props) {

    const [loading, setLoading] = React.useState();
    const [needScroll, setNeedScroll] = React.useState();

    const classes = useStyles();

    const filter = props.filter;
    const params = filter.params;

    const isMobile = props.isMobile;

    const path = window.location.pathname;
    const urlParts = path.split(/\/p\/\d+/);

    const prefix = urlParts[0] === '/' ? '' : urlParts[0];
    const postFix = urlParts[1] ? urlParts[1] : '';

    console.log('urlParts', urlParts);

    const getUrl = page => {
        return  prefix + (page > 1 ? '/p/' + page : '') + postFix;
    };

    const setPageUrl = (url) => {
        window.history.pushState({path: url}, window.title, url);
    };

    const handleChange = (e, p) => {
        if (params.page === p) {
            return;
        }
        params.page = p;
        setNeedScroll(true);
        setLoading(true);
       // setPageInUrl(p);
        filter.dispatchFilter(false);
    };

    //const render = () => {
      //  setCounter(counter + 1);
    //};

    filter.addCallback('pager', () => {
        setLoading(false);
        if (needScroll) {
            setNeedScroll(false);
            window.scrollTo(0, 0);
        }

       // render();
    });

    if (path !== props.data.seo.path) {
        setPageUrl(props.data.seo.path);
    }

    return <div className={isMobile ? classes.rootMobile : classes.root}>
       <MemoryRouter initialEntries={[path]} initialIndex={0}>
        <Route>
            {({ location }) => {
                return (
                    <Pagination
                        page={params.page}
                        count={Math.ceil(params.total / params.limit)}
                        variant="outlined"
                        shape="rounded"
                        onChange={handleChange}
                        renderItem={(item) => (
                            <PaginationItem
                                component={Link}
                                to={getUrl(item.page)}
                                {...item}
                            />
                        )}
                    />
                );
            }}
        </Route>
    </MemoryRouter>
    {loading ? <LinearProgress className={classes.loader}/> : null}
    </div>
}